export default "__VITE_ASSET__COLk7pxY__"